import Nullstack from 'nullstack';
export default function IconRoadOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-road-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 19l3.332 -11.661"
  }), "   ", Nullstack.element("path", {
    d: "M16 5l2.806 9.823"
  }), "   ", Nullstack.element("path", {
    d: "M12 8v-2"
  }), "   ", Nullstack.element("path", {
    d: "M12 13v-1"
  }), "   ", Nullstack.element("path", {
    d: "M12 18v-2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}